import React from 'react';
import {Subscribe} from 'unstated';
import InvoiceDataContainer from '../Stores/InvoiceDataContainerStore';
import PaymentDataContainer from '../Stores/PaymentDataContainerStore';
import myGlobals from '../Utils/globals';
import myUtilities from '../Utils/utils';
import onlinePaymentsIntermediate from '../Utils/onlinePaymentsIntermediate';
import MyNotificationSystem from '../Components/MyNotificationSystem';
import Alert from 'react-bootstrap/Alert';
import { Dropdown, ButtonGroup, Button } from "react-bootstrap";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as alertActions from "../redux/actions/alertAction";
import utils from "../Utils/utils";

class OnlinePaymentMethods extends React.Component{
    constructor(props){
        super(props);
        this.state={
            options: [
                {
                    value: '',
                    displayName: 'Select Country'
                }
            ],
            selectedValue: null,
            acctHolderName : null,
            invalidChars : "",
            showAlert: false,
            selectedCountry: myUtilities.accountSpecificLanguage(
        		"OnlinePaymentMethods.ChooseCountryDropdowm",
        		"Choose Bank Country :"
      		),
      		mapKey: ''
      		
        }
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.handleHolderNameChange = this.handleHolderNameChange.bind(this);
        this.invdata=null;
        this.paydata=null;
    }
   callAlertActions = (id, message) =>
  		this.props.alertActions.alertAlertAtion({ id: id, message: message });
    setContainers = (invdata,paydata) => {
        this.invdata = invdata;
        this.paydata = paydata;
    }
    populateCountryOptions = () => {
        let result = [];
        for(let i=0;i<this.state.options.length;++i){
              let optionClass =
			        this.state.selectedValue === null
			          ? ""
			          : this.state.selectedValue === this.state.options[i].value
			          ? "clicked"
			          : "";
		      result.push(
		        <Dropdown.Item eventKey={i} className={optionClass}>
		          {this.state.options[i].displayName}
		        </Dropdown.Item>
		      );
        }
        return result;
    }
    onClick = (invData) => {
    	let self = this;
    	let value = this.state.acctHolderName;
		let asciiRegex =/[\x00-\x7F]/;
		let failedChars = "";
	   	if(value != null && value.trim().length !=0 ){
	   		for (let i = 0; i < value.length; i++) {
		    	if (!asciiRegex.test(value[i]) && failedChars.indexOf(value[i]) == -1) {
		    		failedChars = failedChars + value[i]+" , ";
		     	}
		   	}
	    }
    	if(this.state.selectedValue===null || this.state.selectedValue.trim().length===0 ){
          this.callAlertActions("OnlinePaymentMethods.ChooseCountry", "Please choose bank country before proceeding");
        }else if(this.state.acctHolderName===null || this.state.acctHolderName.trim().length===0 ){
           this.callAlertActions("OnlinePymentMethods.AccountHolderNameMissing", "Please enter Account Holder Name before proceeding");
        }else if(failedChars.trim() != ""){
            this.setState({
                showAlert: true
              });
              setTimeout(()=>{
                this.setState({
                  showAlert: false
//                  invalidChars : failedChars
                })},3000);
        	//myUtilities.addNotification(undefined,"ASCII_ONLY",failedChars.substring(0,failedChars.lastIndexOf(",")));
	   	}else if(invData.state.paymentOnAccount){
            const searchParams = new URLSearchParams();
            searchParams.append('paymentMethod',this.props.paymentMethod);
            searchParams.append('onDemandAccountId',invData.state.onDemandAccountId);
            searchParams.append('customerMapId',invData.state.pkMcarId);
            searchParams.append('currency',invData.state.currency);
            searchParams.append('paymentAmount',invData.getTotalInvoiceAmount(invData.state.invoices));
            searchParams.append('countryCode',this.state.selectedValue);
            searchParams.append('acctHolderName',this.state.acctHolderName);
            searchParams.append('publicKeyUI', invData.state.publicKey);
            searchParams.append('token',myGlobals.token);
            searchParams.append('languageCode',myGlobals.pmtLanguageCode);
            if(null != invData.state.remittanceFormData){
	            const keys = Object.keys(invData.state.remittanceFormData);
	    		for(let i=0;i<keys.length;i++){
	    			if(keys[i].localeCompare('showAlert')!=0 && keys[i].localeCompare('totalAmount')!=0){
	    				searchParams.append(keys[i],invData.state.remittanceFormData[keys[i]]);
	    			}
	    		}
	    	}
            let link = "invokeOBPPaymentOnAccount";
            link = myGlobals.initialHost+myGlobals.appender+link;
          //  link='https://api.myjson.com/bins/15j0i6';
            fetch(link , {
                method: "POST",
                body: searchParams
            }).then(
                function(response){
                    if (response.status !== 200) {
                      console.log('Looks like there was a problem. Status Code: ' +
                        response.status);
                      return;
                    }
                    return response.json();
                  }
            ).then(function(data){
                onlinePaymentsIntermediate.response = data;
                console.log('OBP Data: ' , data.rows);
                myGlobals.selectedStateMethodPaymentContainer('ONLINEPAYMENTDI');
              }).catch(
                function(err)
                {
                  console.log('Fetch Error :-S',err);
                  //this.paydata.setPaymentFailed();
                    self.callAlertActions("OnlinePaymentMethods.MissingConfigs", "Configurations not present, Please retry with other payment method");
                    myGlobals.selectedStateMethodPaymentContainer('SELECTION');
                }
            );
        }else{
            const searchParams = new URLSearchParams();
            searchParams.append('onDemandAccountId',invData.state.onDemandAccountId);
            searchParams.append('currency',invData.state.currency);
            searchParams.append('globalAccountId',invData.state.globalAccountId);
            searchParams.append('pkMapCustomerAccountRad',invData.state.pkMcarId);
			searchParams.append('languageCode',myGlobals.pmtLanguageCode);
            // let invoiceNumbers="" ;
            // invData.state.invoices.forEach((invoice)=>{                                                     
            //     invoiceNumbers+=invoice.accountDocHeaderId+',';
            // });
            // invoiceNumbers=invoiceNumbers.substring(0,invoiceNumbers.length-1);

            let invoices = invData.state.selectedInvoices;
            let invoiceList = invoices.map((invoice)=>
                 invoice.accountDocHeaderId+'@'+invoice.payableAmount2
            )
            console.log("invoiceList  is "+invoiceList);
            searchParams.append('invoiceNumbers',invoiceList);
            searchParams.append('paymentMethod',this.props.paymentMethod);
            searchParams.append('countryCode',this.state.selectedValue);
            searchParams.append('acctHolderName',this.state.acctHolderName);
            searchParams.append('customerMapId',invData.state.pkMcarId);
            searchParams.append('paymentAmount',invData.getTotalInvoiceAmount(invData.state.selectedInvoices));
            searchParams.append('token',myGlobals.token);
            searchParams.append('publicKeyUI', invData.state.publicKey);
            
             let link = "invokeOnlineBankPayment";
             link = myGlobals.initialHost+myGlobals.appender+link;
           //  link='https://api.myjson.com/bins/15j0i6';
             fetch(link , {
                 method: "POST",
                 body: searchParams
             }).then(
                 function(response){
                     if (response.status !== 200) {
                       console.log('Looks like there was a problem. Status Code: ' +
                         response.status);
                       return;
                     }
                     return response.json();
                   }
             ).then(function(data){
                 onlinePaymentsIntermediate.response = data;
                 console.log('OBP Data: ' , data.rows);
                 myGlobals.selectedStateMethodPaymentContainer('ONLINEPAYMENTDI');
               }).catch(
                 function(err)
                 {
                   console.log('Fetch Error :-S',err);
                   //this.paydata.setPaymentFailed();
                   self.callAlertActions("OnlinePaymentMethods.MissingConfigs", "Configurations not present, Please retry with other payment method");

                     myGlobals.selectedStateMethodPaymentContainer('SELECTION');
                 }
             );
        }
    }
	handleDropdownChange(index) {
	    if (index && !isNaN(index) && index != 0) {
	      let selectedOption = this.state.options[index];
	      this.setState({
	        selectedValue: selectedOption.value,
	        selectedCountry: selectedOption.displayName,
        mapKey: this.props.paymentMethod+'_'+selectedOption.value
	      });
	    }
	  }
    
    alertContent = () => {
        if(this.state.showAlert){
        return (
          <Alert className="my-alert-class" variant="danger">
          <p>
          {myUtilities.accountSpecificLanguage("Validation.invalidAccountHolderName", "Please enter valid name. Accented characters are not permitted like ")}
        	  &nbsp;{this.state.invalidChars} .
          </p>
        </Alert>
        );
        }
    } 

   handleHolderNameChange(e){
   			let value = e.target.value;
   			let asciiRegex =/[\x00-\x7F]/;
   			let failedChars = "";
		   	if(value != null && value.trim().length !=0 ){
		   		for (let i = 0; i < value.length; i++) {
			    	if (!asciiRegex.test(value[i]) && failedChars.indexOf(value[i]) == -1) {
			    		failedChars = failedChars + value[i]+" , ";
			     	}
			   	}
		    }
		   	if(failedChars.trim() != ""){
                this.setState({
                    showAlert: true,
                    invalidChars : failedChars.substring(0,failedChars.lastIndexOf(","))
                  });
                  setTimeout(()=>{
                    this.setState({
                      showAlert: false,
                    })},3000);
		   		//myUtilities.addNotification(e,"ASCII_ONLY",failedChars.substring(0,failedChars.lastIndexOf(",")));
		   	}else{
		   		this.setState({ invalidChars : "" });
		   	}
   			this.setState({ acctHolderName : value });
   		}

    cancelOnClick = (paymentData,invData) => {
        if(myGlobals.checkPaymentContentSelected().localeCompare('SELECTION')!==0){
            myGlobals.selectedStateMethodPaymentContainer('SELECTION');
            let discVal = invData.getTotalDiscountAmount(
              invData.state.selectedInvoices
            );
            let totalAmt = invData.getTotalInvoiceAmount(invData.state.selectedInvoices);
            if (myGlobals.isDiscountEnabled) {
              totalAmt = parseFloat(totalAmt) - parseFloat(discVal);
            }
            totalAmt = parseFloat(totalAmt).toFixed(2);
            invData.setState({
              total: totalAmt,
              totalDiscVal: discVal
            });	
            paymentData.setTotalConvenienceFeeAndSurcharge(null,null);
        }
      }
    render(){
        return(
            <Subscribe to={[InvoiceDataContainer]}> 
            
            {invdata=>(
                <Subscribe to={[PaymentDataContainer]}>
                {paydata=>(
                    <div className="trustly-container trustly-top-margin">
                        {this.setContainers(invdata,paydata)}
                    <div id="payment-summary-header">
                      {myUtilities.accountSpecificLanguage("Header.PaymentSummary", "Payment Summary")}
                    </div>
                    <div className ="trustly-top-margin">
                    {myUtilities.accountSpecificLanguage("OBP.Message.AmtPayable", "Amount Payable")} : 
                    <div className ="trustly-total">
                        {utils.toStringUtil(invdata.state.total, 'total')}
                    </div>
                    </div>
                    <div className="obp-button-containers">
                    {this.alertContent()}
                    {/* <MyNotificationSystem /> */}
                    <div className ="trustly-top-country-margin"/>
                    {myUtilities.accountSpecificLanguage("OnlinePaymentMethods.ChooseCountryDropdowm", "Choose Bank Country")} :
                        <div>
                    <Dropdown
                    
                      onSelect={(evt) => this.handleDropdownChange(evt)}
                      as={ButtonGroup}
                    >
                      <Button className="choose-country-btn" variant="success">
                        {this.state.selectedCountry}
                      </Button>
                      <Dropdown.Toggle
                        split
                        variant="success"
                        id="dropdown-split-basic"
                      />
                      <Dropdown.Menu>
                            {this.populateCountryOptions()}
                      </Dropdown.Menu>
                    </Dropdown>
                        </div>
                    <div className ="trustly-top-country-margin"/>
                      {myUtilities.accountSpecificLanguage("OBP.Label.AccHolderName", "Account Holder Name")} :
                        <div>
                        <input type = 'text' onChange={this.handleHolderNameChange} />
                            
                        </div>
                    </div>   
                     {typeof myGlobals.PPRO_TNC_INFO[this.state.mapKey] !==
                  "undefined" && (
                  <div class="privacy-hyperlink-div">
                    <a
                      class="privacy-hyperlink"
                      href={myGlobals.PPRO_TNC_INFO[this.state.mapKey]}
                      target="_blank"
                    >
                      {myUtilities.accountSpecificLanguage("OnlinePaymentMethods.PrivacyLink","Click here to read the privacy policy")}
                    </a>
                  </div>
                )} 
                    
                    <div className="trustly-buttons">
                    	<button className="trustly-cancel-button mainapp-button" onClick={()=>{this.cancelOnClick(this.paydata,this.invdata)}}>{myUtilities.accountSpecificLanguage("AlertDialog.Cancel", "Cancel")}</button>
                    	<button className="trustly-proceed-button mainapp-button" onClick={()=>{this.onClick(this.invdata)}}>{myUtilities.accountSpecificLanguage("proceed", "Proceed")}</button>
                    </div>
                    </div>
                )}
                </Subscribe>   

                //return("LOL");
            )}
            </Subscribe>
        );
    }

    componentDidMount(){
        const searchParams = new URLSearchParams();
        console.log("payment method is :"+this.props.paymentMethod);
        searchParams.append('paymentMethod',this.props.paymentMethod);
        searchParams.append('onDemandAccountId',this.invdata.state.onDemandAccountId);
        searchParams.append("token", myGlobals.token);
        //let link = "https://api.jsonbin.io/b/5f0ee237c58dc34bf5d3d8a2";
        let link = "getPaymentMethodCountryMapping";
        link = myGlobals.initialHost+myGlobals.appender+link;
        fetch(link, {
            //fetch('https://api.jsonbin.io/b/5ef46ee92406353b2e0c6919/2', {
            method: "POST",
            body: searchParams
        })
         //fetch('https://api.myjson.com/bins/1gqpzg', {

          //  method: "GET"
    
          // })
        .then(
        function(response){
            if (response.status !== 200) {
            console.log('Looks like there was a problem. Status Code: ' +
                response.status);
            return;
            }
            return response.json();
        }
        ).then(
            data=>{
            // console.log(data);
            // console.log(data.rows);
            
            if(data != undefined && data.rows != undefined && data.rows.failureReason && data.rows.failureReason === 'LINK_EXPIRED'){
              myGlobals.errorMessage = myUtilities.accountSpecificLanguage("Error.LinkExpired", "Link has expired");
              myGlobals.getHistory.replace(`/linkExpired`);
              return;
            }
  				      
            
            let country = null;
            let countryName = this.state.selectedCountry;
            if(data.rows.length >1){
            	country = data.rows[1].value;
            	countryName = data.rows[1].displayName;
            }
            this.setState({
                options: data.rows,
                selectedValue : country,
                selectedCountry: countryName,
                mapKey: this.props.paymentMethod+'_'+country
                
            })
        }).catch(
        function(err)
        {
            console.log('Fetch Error :-S',err);
            //onFailure(err);
        }
        );
}
}

const mapDispatchToProps = (dispatch) => ({
  alertActions: bindActionCreators(alertActions, dispatch),
});

export default connect(null, mapDispatchToProps)(OnlinePaymentMethods);